import { CSSProperties, useEffect } from "react";

type BottomUpModalWrapperProps = {
  isOpen: boolean;
  onClose: () => void;
  activeEsc?: boolean;
  children: React.ReactNode;
};

const BottomUpModalWrapper: React.FC<BottomUpModalWrapperProps> = ({
  isOpen,
  onClose,
  activeEsc = true,
  children,
}) => {
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (activeEsc && e.key === "Escape") onClose();
    };

    if (isOpen) {
      // 모달이 열릴 때 메인 컨텐츠에 패딩 추가
      const mainContent = document.getElementById("root") || document.body;
      mainContent.style.paddingBottom = "50vh"; // 모달 높이만큼 패딩 추가
      window.addEventListener("keydown", handleEsc);
    }

    return () => {
      // 모달이 닫힐 때 패딩 제거
      const mainContent = document.getElementById("root") || document.body;
      mainContent.style.paddingBottom = "0";
      window.removeEventListener("keydown", handleEsc);
    };
  }, [isOpen, onClose, activeEsc]);

  if (!isOpen) return null;

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div style={styles.bottomUpModalWrapper}>
      <div style={styles.fullOverlay} onClick={handleOverlayClick} />
      <div style={styles.modalContent}>{children}</div>
    </div>
  );
};

const styles: Record<string, CSSProperties> = {
  bottomUpModalWrapper: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    pointerEvents: "none",
    zIndex: 9999,
  },
  fullOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    pointerEvents: "auto",
  },
  modalContent: {
    position: "fixed", // absolute에서 fixed로 변경
    bottom: 0,
    left: 0,
    width: "100%",
    height: "50vh",
    backgroundColor: "white",
    borderTopLeftRadius: "16px",
    borderTopRightRadius: "16px",
    boxShadow: "0px -4px 10px rgba(0, 0, 0, 0.1)",
    overflow: "auto",
    pointerEvents: "auto",
  },
};

export default BottomUpModalWrapper;
